import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "i-911786224__icon",
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M512 0c282.752 0 512 229.248 512 512s-229.248 512-512 512S0 794.752 0 512 229.248 0 512 0zm0 78.763C272.725 78.763 78.763 272.725 78.763 512S272.725 945.237 512 945.237 945.237 751.275 945.237 512 751.275 78.763 512 78.763z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M513.195 718.763v-59.051H268.032V532.053H488.96V472.96H268.032V356.053h235.093V296.96H198.912v421.803h314.283zm141.184 0V535.04c2.346-24.235 10.666-43.093 24.789-56.107 12.416-11.818 27.179-17.749 43.733-17.749 46.08 0 69.12 24.832 69.12 75.05v182.529h67.371V530.347c0-83.883-38.4-125.227-114.645-125.227-18.304 0-34.859 3.541-50.219 11.221a122.027 122.027 0 0 0-40.15 32.47v-35.414h-67.37v305.408h67.37z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "en"}) } }